<template>
  <v-card outlined>
    <v-row align="center" justify="center" class="mx-0">
      <v-col class="text-center" v-if="isBig">
        <v-icon large color="primary"> {{ icon }} </v-icon>
        <div class="display-1 text--primary">
          {{ count }}{{ percent ? "%" : "" }}
        </div>
        <div class="headline text--primary">{{ title }}</div>
      </v-col>
      <v-col class="text-center" v-else>
        <v-icon class="mx-0 pa-0" color="primary"> {{ icon }} </v-icon>
        <div class="title text--primary">
          {{ count }}{{ percent ? "%" : "" }}
        </div>
        <div class="text--primary">
          {{ title }}
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import anime from "animejs/lib/anime.es.js";
export default {
  props: ["title", "value", "icon", "isBig", "percent"],
  data() {
    return {
      count: 0,
    };
  },
  watch: {
    value(value) {
      this.setCount(value);
    },
  },
  methods: {
    setCount(val) {
      const obj = { n: this.count };
      anime({
        targets: obj,
        n: val,
        round: 5,
        duration: 500,
        easing: "linear",
        update: () => {
          this.count = obj.n.toLocaleString();
        },
      });
    },
  },
  mounted() {
    this.setCount(this.value);
  },
};
</script>

<style>
</style>